module.exports = __webpack_public_path__ + "static/media/33-6.f15c971c.mp3";